import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import SVG from 'react-inlinesvg';
import ConfigContext from '../../../contexts/ConfigContext';

import styles from './QuoteCta.module.postcss';

function QuoteCta() {
  const { city_name, vehicle_type } = useContext(ConfigContext);
  const vehicleType = vehicle_type.toLowerCase();

  return (
    <div className={styles.QuoteCta}>
      <div className={styles.QuoteCta_inner}>
        <SVG
          src='/static/images/catering-banner-logo.svg'
          width='48'
          height='48'
        />
        <div className='u-strong'>Planning an event? Get free quotes from {city_name} food {vehicleType}s.</div>
      </div>
      <Link to='/catering/requests/new' className='Button'>
        Get catering quotes
      </Link>
    </div>
  );
}

export default QuoteCta;
